// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ComplaintList_tableWrapper__zM41x","reason":"ComplaintList_reason__oszKd"};